import { getDatabase, ref, push, onValue, remove } from 'firebase/database';
import { database } from '../firebase/config';

const NOTIFICATIONS_PATH = '/notificacoes';

export const notificationsService = {
  enviarNotificacao: async ({ grupoId, grupoNome, usuarioId, usuarioNome, status, destinatarios }) => {
    
    if (!grupoId || !usuarioId || !status || !destinatarios || destinatarios.length === 0) return;
    
    // Verificar se o database está disponível
    if (!database) {
      console.warn('Firebase Realtime Database não está configurado. Notificações não funcionarão.');
      return;
    }
    
    const db = database;
    const notificacao = {
      grupoId,
      grupoNome,
      usuarioId,
      usuarioNome,
      status,
      timestamp: Date.now(),
      lidaPor: []
    };
    const promises = destinatarios.map(uid => {
      const userRef = ref(db, `${NOTIFICATIONS_PATH}/${uid}`);
      return push(userRef, notificacao);
    });
    await Promise.all(promises);
  },

  escutarNotificacoes: (usuarioId, callback) => {
    if (!usuarioId) return;
    
    // Verificar se o database está disponível
    if (!database) {
      console.warn('Firebase Realtime Database não está configurado. Notificações não funcionarão.');
      return;
    }
    
    const db = database;
    const userRef = ref(db, `${NOTIFICATIONS_PATH}/${usuarioId}`);
    return onValue(userRef, snapshot => {
      const data = snapshot.val() || {};
      const lista = Object.entries(data).map(([id, n]) => ({ id, ...n }));
      callback(lista.sort((a, b) => b.timestamp - a.timestamp));
    });
  },

  marcarComoLida: async (usuarioId, notificacaoId) => {
    if (!usuarioId || !notificacaoId) return;
    
    // Verificar se o database está disponível
    if (!database) {
      console.warn('Firebase Realtime Database não está configurado. Notificações não funcionarão.');
      return;
    }
    
    const db = database;
    const notifRef = ref(db, `${NOTIFICATIONS_PATH}/${usuarioId}/${notificacaoId}`);
    await remove(notifRef);
  }
};
